import { DpCheckbox } from '@/components/blocks/DpCheckbox';
import { Img } from '@/components/blocks/MaterialImage';
import { OutfitItemPrice } from '@/components/blocks/ModalOutfits/parts/OutfitItem/parts/OutfitItemPrice';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { Box, Typography } from '@mui/material';
import { SizeSelect } from '@/components/blocks/EmailRecommendedCouponPopup/parts/SizeSelect';
import { ProductWithSizes } from '@/components/blocks/EmailRecommendedCouponPopup/parts/types';
import {
	productImageFrameSX,
	productImageSX,
	productInfoSX,
	productNameSX,
	productPriceSizeRowSX,
	productRowSX,
} from '@/components/blocks/EmailRecommendedCouponPopup/styles';

interface ProductItemProps {
	product: ProductWithSizes;
	checked: boolean;
	selectedChild: string | null;
	onToggle: (parentPartNumber: string) => void;
	onSelectSize: (parentPartNumber: string, childPartNumber: string) => void;
}

export const ProductItem = ({
	product,
	checked,
	selectedChild,
	onToggle,
	onSelectSize,
}: ProductItemProps) => (
	<Box sx={productRowSX}>
		<DpCheckbox checked={checked} onChange={() => onToggle(product.partNumber)} />
		<Box sx={productImageFrameSX}>
			<RenderProductImg
				fullImageRaw={product.thumbnail}
				render={(src) => <Img src={src} alt={product.name} sx={productImageSX} />}
			/>
		</Box>
		<Box sx={productInfoSX}>
			<Typography component="h3" sx={productNameSX}>
				{product.name}
			</Typography>
			<Box sx={productPriceSizeRowSX}>
				<OutfitItemPrice product={product} />
				<SizeSelect
					value={selectedChild || ''}
					sizes={product.sizes}
					onChange={(childPartNumber) => onSelectSize(product.partNumber, childPartNumber)}
				/>
			</Box>
		</Box>
	</Box>
);
